<template>
  <div class="custom-dialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" :before-close="handleClose" :close-on-click-modal="false">
      <slot></slot>
      <template #footer>
        <slot name="footer">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String,
      default: '标题'
    },
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%'
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);;
    }
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false;
      this.$emit('before-close', done);
    },
    handleCancel() {
      this.dialogVisible = false;
      this.$emit('dialog-cancel');
    },
    handleConfirm() {
      this.$emit('dialog-confirm');
      // this.dialogVisible = false;
    }
  }
};
</script>

<style lang='scss'>
.custom-dialog {
  .el-dialog__body {
    // width: 90%;
    display: flex;
    justify-content: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/studentCenter/Dialog/index.vue